<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="card-title p-0 m-0 fw-normal">
                        <template v-if="Object.keys($props.ticketDetails).length">Discussion on "{{ $props.ticketDetails.title }}"</template>
                        <template v-else>Select ticket to start discussion</template>
                        <a class="btn btn-theme btn-sm cursor-pointer float-end" data-bs-toggle="modal" data-bs-target="#createTicket">Create a new ticket</a>
                    </h5>
                </div>
                <div class="card-body pt-0 pb-0">
                    <div class="row h-100 chat-body">
                        <div class="col-md-3 mb-4 mb-md-0 ps-1 pt-3 border-end">
                            <div class="">
                                <div class="scrollbar position-relative overflow-auto" style="height: 350px">
                                    <ul v-if="tickets.length" class="list-unstyled mb-0 pe-2">
                                        <li class="ps-1 pt-2 pb-2">
                                            <input type="text" class="form-control form-control-sm rounded-1" placeholder="Search..." v-model="filters.search">
                                        </li>
                                        <li class="ps-1 pb-4 d-flex justify-content-between">
                                            <div class="">
                                                <select v-model="filters.status" class="form-select form-select-sm">
                                                    <option value="all">All</option>
                                                    <option value="open">Open</option>
                                                    <option value="closed">Closed</option>
                                                </select>
                                            </div>
                                            <div class="">
                                                <select v-model="filters.sort" class="form-select form-select-sm">
                                                    <option value="desc">Newest</option>
                                                    <option value="asc">Oldest</option>
                                                </select>
                                            </div>
                                        </li>
                                        <li
                                            v-for="ticket in filteredTickets"
                                            :key="ticket.id"
                                            class="ps-1 rounded-1"
                                            :class="{ 'bg-light': ticket.uuid == $props.uuid }"
                                        >
                                            <a :href="`/admin/tickets/discussion/${ticket.uuid}`" class="d-flex justify-content-between">
                                                <div class="d-flex flex-row align-self-center">
                                                    <div class="hm-chat-user-icon align-self-center">
                                                        <div class="">{{ ticket.user.initials }}</div>
                                                    </div>
                                                    <div class="pt-1 ps-2 align-self-center mt-2">
                                                        <p class="fw-bold mb-0">{{ $truncateString(ticket.title, 20) }}</p>
                                                        <p class="small text-muted hm-fs-11">{{ ticket.ticket_number }}</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- Include ticket chat -->
                        <div class="col-md-9">
                            <ticket-chat :uuid="uuid" :user="user" :currency="currency"></ticket-chat>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Create ticket modal -->
    <div class="modal fade" id="createTicket" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div" id="create-ticket-form" name="create-ticket-form">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Ticket</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col-md-12">
                                <label for="title" class="form-label">Title <span class="text-danger">*</span></label>
                                <Field
                                    type="text"
                                    class="form-control"
                                    name="title"
                                    placeholder="Enter title"
                                    v-model="createTicket.title"
                                    :class="{ 'is-invalid': errors.title }"
                                ></Field>
                                <div v-if="errors.title" class="is-invalid invalid-feedback">{{ errors.title }}</div>
                            </div>
                            <div class="col-md-12">
                                <label for="orderId" class="form-label">Select Order</label>
                                <Field
                                    name="orderId"
                                    :value="createTicket.orderId"
                                    v-slot="{ field }"
                                >
                                    <vue-multiselect
                                        v-bind="field"
                                        v-model="createTicket.order"
                                        :class="{ 'is-invalid': errors.orderId }"
                                        :options="orderOptions"
                                        placeholder="Search order"
                                        :show-labels="tyr"
                                        track-by="order_label"
                                        label="order_label"
                                        @select="selectOrder"
                                    ></vue-multiselect>
                                </Field>
                                <div v-if="errors.orderId" class="is-invalid invalid-feedback">{{ errors.orderId }}</div>
                            </div>
                            <div class="col-md-12">
                                <label for="message" class="form-label">Message <span class="text-danger">*</span></label>
                                <Field
                                    as="textarea"
                                    class="form-control"
                                    name="message"
                                    placeholder="Enter message"
                                    rows="4"
                                    v-model="createTicket.message"
                                    :class="{ 'is-invalid': errors.message }"
                                ></Field>
                                <div v-if="errors.message" class="is-invalid invalid-feedback">{{ errors.message }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button
                            type="button"
                            class="btn btn-theme"
                            :disabled="processing"
                            :class="{ 'disabled cursor-not-allowed': processing }"
                            v-text="processing ? 'Processing...' : 'Create'"
                            @click="handleSubmit($event, createNewTicket)"
                        ></button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
import {Field} from "vee-validate";
import TicketChat from "./TicketChat";

export default {
    name: 'TicketComponent',
    props: {
        uuid: {
            type: String,
            default: () => ('')
        },
        ticketDetails: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        Field,
        TicketChat
    },
    data() {
        return {
            processing: false,
            createTicket: {
                title: '',
                message: '',
                orderId: null,
                order: {},
            },
            ticket: {}, // current ticket
            tickets: [], // all tickets
            currency: '£',
            orders: [],
            orderOptions: [],
            user: {},
            filters: {
                search: '',
                status: 'open',
                sort: 'desc'
            }
        }
    },
    created() {
        // Check if ticket details not empty then set the values to the ticket object
        if(Object.keys(this.ticketDetails).length) {
            this.ticket = this.ticketDetails;
        }

        // Get provider orders
        this.getOrders();

        // Get provers tickets
        this.getProversTickets();
    },
    computed: {
        schema() {
            const schemas = {
                title: 'required',
                message: 'required',
            };
            return schemas;
        },
        filteredTickets() {
            const query = this.filters.search.toLowerCase();
            const statusFilter = this.filters.status;
            let filtered = this.tickets.filter(ticket => {
                // Filter by search term
                const matchesSearch =
                ticket.title.toLowerCase().includes(query) ||
                ticket.message.toLowerCase().includes(query) ||
                ticket.user.full_name.toLowerCase().includes(query) ||
                ticket.user.email.toLowerCase().includes(query) ||
                (ticket.order &&
                    (ticket.order.order_number.toLowerCase().includes(query) ||
                    ticket.order.booking_address.toLowerCase().includes(query)));

                // Filter by status
                const matchesStatus = statusFilter === 'all' || ticket.status === statusFilter;

                return matchesSearch && matchesStatus;
            });

            // Sort the filtered results
            if (this.filters.sort === 'asc') {
                filtered = filtered.sort((a, b) =>
                    a.created_at > b.created_at ? 1 : -1
                );
            } else {
                filtered = filtered.sort((a, b) =>
                    a.created_at < b.created_at ? 1 : -1
                );
            }

            return filtered;
        }
    },
    methods: {
        getOrders() {
            let self = this;
            axios.post('/admin/tickets/get-orders')
                .then((response) => {
                    if(response.data.status === 'success') {
                        self.orders = response.data.orders;
                        self.currency = response.data.currency;

                        // Prepare the order options
                        self.orderOptions = self.orders.map((order) => {
                            return {
                                id: order.id,
                                order_number: order.order_number,
                                order_label: order.full_name + ' - ' + order.full_address
                            };
                        });
                    };
                })
        },
        createNewTicket() {
            let self = this;
            self.processing = true;
            axios.post('/admin/tickets', self.createTicket)
                .then((response) => {
                    if(response.data.status === 'success') {
                        self.$notification('success', response.data.message);
                        window.location.href = response.data.redirect_url;
                    }
                })
                .catch((error) => {
                    let message = error.response.data.message;
                    self.$notification('error', message);
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        selectOrder(order) {
            this.createTicket.orderId = order.id;
        },
        getProversTickets() {
            let self = this;
            axios.post('/admin/tickets/get-provers-tickets')
                .then((response) => {
                    if(response.data.status === 'success') {
                        self.tickets = response.data.tickets;
                        self.user = response.data.user;
                    }
                })
        },
    }
}
</script>
